import axios from '@/utils/request';

// 获取培训班类别
export const getCatalogs = (data: any) => {
  return axios.request({
    url: 'TrainClass/GetCatalogs',
    method: 'GET',
    params: data,
  });
};

// 获取培训班列表
export const getTrainClasses = (data: any) => {
  return axios.request({
    url: 'TrainClass/GetTrainClasses',
    method: 'GET',
    params: data,
  });
};

// 获取我的培训班
export const getMyTrainClasses = (data: any) => {
  return axios.request({
    url: 'TrainClass/GetMyTrainClasses',
    method: 'GET',
    params: data,
  });
};

// 获取培训班详细
export const getTrainClassDetails = (data: any) => {
  return axios.request({
    url: 'TrainClass/GetTrainClassDetails',
    method: 'GET',
    params: data,
  });
};

// 获取培训阶段活动类型
export const getTrainStageRelationTypes = (data: any) => {
  return axios.request({
    url: 'TrainClass/GetTrainStageRelationTypes',
    method: 'GET',
    params: data,
  });
};

// 培训班报名
export const handleSignUp = (data: any) => {
  return axios.request({
    url: 'TrainClass/HandleSignUp',
    method: 'POST',
    params: data,
  });
};

// 培训班交作业
export const submitHomework = (data: any) => {
  return axios.request({
    url: 'TrainClass/SubmitHomework',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 培训班删除作业
export const delHomework = (data: any) => {
  return axios.request({
    url: 'TrainClass/DelHomework',
    method: 'POST',
    params: data,
  });
};

// 获取培训相册列表
export const getTrainAlbums = (data: any) => {
  return axios.request({
    url: 'TrainAlbum/GetTrainAlbums',
    method: 'GET',
    params: data,
  });
};
